import { render, staticRenderFns } from "./setRecycle.vue?vue&type=template&id=abd0d6ae&scoped=true"
import script from "./setRecycle.vue?vue&type=script&lang=js"
export * from "./setRecycle.vue?vue&type=script&lang=js"
import style0 from "./setRecycle.vue?vue&type=style&index=0&id=abd0d6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd0d6ae",
  null
  
)

export default component.exports